export const isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);

export const getBrowser = () => {
  const browserInfo = navigator.userAgent;
  if (browserInfo.includes('Opera') || browserInfo.includes('Opr')) return 'opera';
  if (browserInfo.includes('Edg')) return 'edge';
  if (browserInfo.includes('Chrome')) return 'chrome';
  if (browserInfo.includes('Safari')) return 'safari';
  if (browserInfo.includes('Firefox')) return 'firefox';
  return null;
};

export const isFileSystemAccessAPIEnabled = 'showOpenFilePicker' in window;
